import type { ReactNode, LabelHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
  /** Compact uppercase field label style used in filter bars */
  field?: boolean;
}

export function Label({
  children,
  field = false,
  className = "",
  ...props
}: LabelProps) {
  return (
    <label
      className={cn(
        field
          ? "mb-1.5 block text-[10px] font-semibold uppercase tracking-wider text-muted"
          : "text-sm font-medium text-secondary",
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
}
